import { useLayoutEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { setReplayConsent, shouldAskReplayConsent, type ReplayConsent } from '@/utils/clarity';

export default function ReplayConsentBar() {
  const [open, setOpen] = useState(shouldAskReplayConsent);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement.style;
    const sync = () => root.setProperty('--consent-bar-h', `${el.offsetHeight}px`);
    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.removeProperty('--consent-bar-h');
    };
  }, [open]);

  if (!open) return null;

  const choose = (choice: ReplayConsent) => {
    setReplayConsent(choice);
    setOpen(false);
  };

  return (
    <div
      ref={ref}
      role="region"
      aria-label="Session recording consent"
      className="fixed inset-x-0 bottom-0 z-50 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] max-[480px]:p-2 max-[480px]:pb-[max(0.5rem,env(safe-area-inset-bottom))]"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border-2 border-neutral-200 bg-white p-4 shadow-ledge sm:flex-row sm:items-center max-[480px]:flex-row max-[480px]:items-center max-[480px]:gap-2 max-[480px]:p-2">
        <p className="flex-1 text-sm text-neutral-700 max-[480px]:text-xs">
          <span className="max-[480px]:hidden">
            Can we record how you use this site so we can fix confusing pages? What you type stays hidden.
          </span>
          <span className="hidden max-[480px]:inline">Help us improve with session replay?</span>{' '}
          <Link to="/privacy" className="font-semibold text-primary-700 underline">
            Privacy
          </Link>
        </p>
        <div className="flex gap-2">
          <button type="button" className="btn-secondary py-2 max-[480px]:px-3 max-[480px]:py-1.5 max-[480px]:text-sm" onClick={() => choose('declined')}>
            Decline
          </button>
          <button type="button" className="btn-primary py-2 max-[480px]:px-3 max-[480px]:py-1.5 max-[480px]:text-sm" onClick={() => choose('accepted')}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
